/* Auto-load and auto-start 3D models in the product gallery (Dawn / Sense themes).
   v3.
   Why the theme needs a tap:
   - on phones the inline 3D viewer is hidden (CSS) until its slide is marked
     .is-active, which only happens on a thumbnail tap — a swipe just shows the
     preview picture that opens the pop-up;
   - Shopify's 3D viewer UI then stays paused until the model gets focus.
   This script watches the gallery slide that holds the model. When that slide
   is on screen it marks it active (so the viewer is shown), loads the model and
   starts it, without scrolling the page. Does nothing when there is no model. */
(function () {
  if (!('customElements' in window)) return;

  function prepare(el) {
    var tpl = el.querySelector('template');
    var mv = tpl && tpl.content && tpl.content.querySelector('model-viewer');
    if (mv) {
      mv.setAttribute('reveal', 'auto');
      mv.setAttribute('loading', 'eager');
      mv.setAttribute('auto-rotate', '');
      mv.setAttribute('auto-rotate-delay', '0');
      mv.setAttribute('rotation-per-second', '18deg');
    }
  }

  function start3d(el) {
    try {
      if (el.modelViewerUI && typeof el.modelViewerUI.play === 'function') {
        el.modelViewerUI.play();
        return;
      }
    } catch (e) {}
    var mv = el.querySelector('model-viewer');
    var active = document.activeElement;
    if (mv && (!active || active === document.body)) {
      try { mv.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function activateSlide(slide) {
    // Same class the theme sets on a thumbnail tap; it un-hides the inline viewer on phones.
    if (!slide || slide.classList.contains('is-active')) return;
    var list = slide.parentElement;
    if (list) {
      Array.prototype.forEach.call(list.children, function (s) {
        if (s !== slide) s.classList.remove('is-active');
      });
    }
    slide.classList.add('is-active');
  }

  function load(el) {
    if (el.getAttribute('loaded') || el.dataset.autoloadDone) { start3d(el); return; }
    el.dataset.autoloadDone = '1';
    prepare(el);
    var Base = customElements.get('deferred-media');
    try {
      if (Base && Base.prototype && Base.prototype.loadContent) {
        Base.prototype.loadContent.call(el, false); // no focus, no page jump
      } else {
        el.loadContent();
        return;
      }
    } catch (e) {
      try { el.loadContent(); } catch (e2) {}
      return;
    }
    if (window.Shopify && typeof Shopify.loadFeatures === 'function' && typeof el.setupModelViewerUI === 'function') {
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: function (errors) {
            el.setupModelViewerUI(errors);
            if (!errors) start3d(el);
          }
        }
      ]);
    } else {
      start3d(el);
    }
  }

  function init() {
    var models = Array.prototype.filter.call(
      document.querySelectorAll('product-model'),
      function (el) { return !el.closest('product-modal'); } // skip the zoom pop-up copy
    );
    if (!models.length) return;

    var pairs = models.map(function (el) {
      var slide = el.parentElement && el.parentElement.closest('li, .product__media-item');
      return { el: el, target: slide || el.parentElement || el };
    });

    function show(pair) {
      activateSlide(pair.target.tagName === 'LI' || pair.target.classList.contains('product__media-item') ? pair.target : null);
      // let the browser apply the CSS change before loading into the now-visible box
      requestAnimationFrame(function () { load(pair.el); });
    }

    if (!('IntersectionObserver' in window)) {
      pairs.forEach(show);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        for (var i = 0; i < pairs.length; i++) {
          if (pairs[i].target === entry.target) show(pairs[i]);
        }
      });
    }, { rootMargin: '0px', threshold: 0.5 });
    pairs.forEach(function (p) { io.observe(p.target); });
  }

  function boot() {
    var done = false;
    var timer = setTimeout(function () { if (!done) { done = true; init(); } }, 4000);
    customElements.whenDefined('product-model').then(function () {
      if (done) return;
      done = true;
      clearTimeout(timer);
      init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
